import { useMutation, useQuery } from '@tanstack/react-query';
import { withdrawManual, withdrawManualUsdt, depositApiHome, verifyApiHome, dynamicDeposit, depositUsdtGateway, depositManual, getActiveDepositGateways, getActiveWithdrawalGateways, createDynamicDeposit, createDynamicWithdrawal, getCurrencies } from '../api/paymentApi';

export const useWithdrawManualMutation = () => {
  return useMutation({
    mutationFn: withdrawManual,
  });
};

export const useWithdrawManualUsdtMutation = () => {
  return useMutation({
    mutationFn: withdrawManualUsdt,
  });
};

export const useDepositApiHomeMutation = () => {
  return useMutation({
    mutationFn: depositApiHome,
  });
};

export const useVerifyApiHomeMutation = () => {
  return useMutation({
    mutationFn: verifyApiHome,
  });
};

export const useDynamicDepositMutation = () => {
  return useMutation({
    mutationFn: dynamicDeposit,
  });
};

export const useDepositUsdtGatewayMutation = () => {
  return useMutation({
    mutationFn: depositUsdtGateway,
  });
};

export const useDepositManualMutation = () => {
  return useMutation({
    mutationFn: depositManual,
  });
};

export const useActiveGatewaysQuery = (isOpen) => {
  return useQuery({
    queryKey: ['activeGateways'],
    queryFn: async () => {
      const [dep, withdr] = await Promise.all([
        getActiveDepositGateways(),
        getActiveWithdrawalGateways()
      ]);
      const dGateways = dep.success ? dep.data.map(g => ({ ...g, type: 'deposit' })) : [];
      const wGateways = withdr.success ? withdr.data.map(g => ({ ...g, type: 'withdrawal' })) : [];
      return [...dGateways, ...wGateways];
    },
    enabled: isOpen, // Only run the query when the modal is open
    staleTime: 5 * 60 * 1000, // 5 minutes caching
  });
};

export const useCurrenciesQuery = () => {
  return useQuery({
    queryKey: ['currencies'],
    queryFn: async () => {
      const res = await getCurrencies();
      return res.success ? res.currencies : [];
    },
    staleTime: 5 * 60 * 1000,
  });
};

export const useCreateDynamicDepositMutation = () => {
  return useMutation({
    mutationFn: createDynamicDeposit,
  });
};

export const useCreateDynamicWithdrawalMutation = () => {
  return useMutation({
    mutationFn: createDynamicWithdrawal,
  });
};
